import { render } from "./bill_card.vue?vue&type=template&id=1fa10556&scoped=true"
import script from "./bill_card.vue?vue&type=script&lang=js"
export * from "./bill_card.vue?vue&type=script&lang=js"

import "./bill_card.vue?vue&type=style&index=0&id=1fa10556&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa10556"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTr,QTh,QTd,QTable});
